<template>
  <div id="messageAdd" ref="messageRef">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>    
    <v-form ref="formAdd">
      <v-container class="-border" >
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7" v-if="session.role() === 'parent'">
            <v-select 
              v-model="messageTo" 
              @change="changedData" 
              :items="messageGroupList"
              :item-text="item => `${item.name} - (${item.role})`"
              return-object
              label="To"
              :rules="[rules.toRule]"
              class="required pr-4 pl-4"
            >
            </v-select>
          </v-flex>
          <v-flex class="xs12 sm6 md7" v-else>
            <v-autocomplete
                v-model="messageTo" 
                @change="changedData" 
                @keyup.enter="searchFamilies($event)" 
                :items="messageGroupList"
                :item-text="item => `${item.name} - (${item.role})`"
                return-object
                label="To"
                :rules="[rules.toRule]"
                hide-no-data
                id="recipientSearch"
                placeholder="Search by Name / Nickname / Agency / Group"
                :hint="session.role() === 'parent' ? '' : 'Type atleast 3 characters to search'"
                class="required pr-4 pl-4">
                <v-icon slot="append" @click="searchFamilies($event)"> search </v-icon>
              </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field 
              label="Subject" 
              v-model="conversation.subject" 
              class="required pr-4 pl-4" 
              @input="changedData" 
              :rules="[rules.subjectRule]">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
          <v-combobox class="pr-4 pl-4" :rules="[rules.multipleEmail]" @change="changedData" v-model="conversation.cc" label="CC" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
        </v-layout>     
        <v-layout>
          <v-flex>
            <div id="pageEditor">
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption" :content="content" :init="{ height: 300, menubar: false}" :api-key="apikey" v-model="message.content" @input="changedData" :rules="[rules.contentRule]" />
                    <!-- <quill-editor
                      :class="{'height-300': $vuetify.breakpoint.smAndUp}"
                      :content="content"
                      :options="editorOption"
                      @input="changedData"
                      v-model="message.content"
                      :rules="[rules.contentRule]"
                    >
                    </quill-editor> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right" v-if="selectedData">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
/* import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; */
import Editor from '@tinymce/tinymce-vue';

import swal from 'sweetalert2';
import { getCollection, create, getOne, conversationListPopulate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import session from '../../helpers/session';

export default {
  name: 'messageAdd',
  components: {
    Editor
  },
  data: () => ({
    recipientList: [],
    searchAgencyString: '',
    ContactList: [],
    activeContacts: [],
    messageGroupList: [],
    entity: 'Message',
    query: {
      family: ''
    },
    conversationEntity: 'Conversation',
    editor: null,
    config: config,
    apikey: config.tinymceEditorKey,
    content: '',
    selectedData: false,
    agencyAdminList: [],
    editorOption: {
      placeholder: 'Add content here.',
    },
    messageTo: '',
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversation: {
      human: [],
      groups: [],
      subject: '',
      cc: []
    },
    conversationIndex: '',
    rules: {
      subjectRule: (v) => !!v || 'Please enter subject',
      toRule: (v) => !!v || 'Please select recipient',
      contentRule: (v) => !!v || 'Please enter reply',
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address',
    },
  }),  
  computed: {
    ...mapGetters(['Agency', 'Account', 'Message', 'Conversation']),
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    MessageGroup: {
      get () {
        return store.state.MessageGroup;
      },
      set (value) {
        store.commit('setMessageGroup', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
      await this.getAgencyAdmins();
    } else if (session.role() === 'parent') {
      this.getContactList();
    }
    await this.initializeMessageGroups(session.role() === 'parent');
  },
  mounted () {
    this.$refs.messageRef.scrollIntoView({ behavior: 'smooth' });
  },
  methods: {
    async updateConversationList () {
      let sort = { 'updatedAt': -1 };
      let sessionUser = session.getSession();
      let where = {};
      where = {
        $and: [
          {
            $or: [
              {
                human: sessionUser.user.human.id
              }
            ]
          },
          {
            $or: [
              {
                archive: { $exists: false }
              },
              {
                archive: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          },
          {
            $or: [
              {
                removed: { $exists: false }
              },
              {
                removed: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          }
        ]
      };
      if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
        where.$and[0].$or.push({
          groups: {
            $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
          }
        });
      }
      let { error, data } = await getCollection(this.conversationEntity, true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Conversation = data;
        }
      }
    },
    async getContactList () {
      if (!this.ContactList.length) {
        let attributes = 'name,createdAt,_id,is_admin,avatar';
        let populate = [{ path: 'human', select: '_id name user' }];
        let where = { $or: [{ 'account.account': this.Account.id }, { $and: [{ is_admin: true }, { recieve_message: true }] }] };
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.ContactList = data;
            this.getActiveContacts();
          }
        }
      } else {
        this.getActiveContacts();
      }
    },
    async searchFamilies (e) {
      this.recipientList = [];
      this.messageGroupList = [];
      this.messageTo = '';
      this.query.family = e.target.value ? e.target.value : document.querySelector('input[id="recipientSearch"]').value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { };
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.formatMessageList(data, 'parent');
          }
          this.agencyFilter();
          this.groupFilter();
        }
      }
    },
    async agencyFilter () {
      if (this.query.family && this.query.family.length > 2) {
        let filteredList = this.agencyAdminList.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });
        // this.recipientList = [...this.recipientList, ...filteredList];
        this.formatMessageList(filteredList, 'admin');
      }
    },
    async groupFilter () {
      if (this.query.family && this.query.family.length > 2) {
        let filteredList = this.MessageGroup.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });
        this.formatMessageList(filteredList, 'group');
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    async getAgencyAdmins () {
      let where = { is_admin: true, recieve_message: true };
      let attributes = 'name,createdAt,_id';
      let populate = [{ path: 'human', select: '_id name user' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.agencyAdminList = data;
        }
      }
    },
    getActiveContacts () {
      let statusList = ['Active', 'In Progress', 'Approved'];
      let activeAgencies = this.Account.agency.filter(agency => statusList.indexOf(agency.status) > -1);
      activeAgencies = Array.from(activeAgencies, row => row.agency);
      this.activeContacts = Array.filter(this.ContactList, agency => activeAgencies.indexOf(agency.id) !== -1 && !agency.is_admin);
      let isAdmin = this.ContactList.filter(agency => agency.is_admin === true);
      this.activeContacts = [...this.activeContacts, ...isAdmin];
      this.recipientList = [...this.activeContacts];
      this.formatMessageList(this.recipientList, 'agency');
    },
    async initializeMessageGroups (isParent) {
      if (!this.MessageGroup.length) {
        let { error, data } = await getCollection('MessageGroup', true, 0);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load message groups'
          };
        } else {
          if (data.length > 0) {
            this.MessageGroup = data;
            if (isParent) {
              this.formatMessageList(data, 'group');
            }
          }
        }
      } else if (isParent) {
        this.formatMessageList(this.MessageGroup, 'group');
      }
    },
    async formatMessageList (filteredList, type) {
      if (filteredList.length) {
        filteredList.forEach(item => {
          let obj = {
            type: type,
            id: type === 'group' ? item.id : item.human[0].id,
            name: item.name,
            role: type
          };
          this.messageGroupList.push(obj);
        });
      }
    },

    async save () {
      if (this.$refs.formAdd.validate()) {
        if (!this.message.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Content is required.',
            text: 'Please add message content before saving!',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        this.selectedData = false;
        if (this.conversation.cc && !this.conversation.cc.length) {
          delete this.conversation.cc;
        }
        if (this.messageTo) {
          if (this.messageTo.type === 'group') {
            this.conversation.groups.push(this.messageTo.id);    
          } else {
            this.conversation.human.push(this.messageTo.id);
          }
        }
        if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
          this.conversation.human.push(this.Agency.human[0]);
        } else if (session.role() === 'parent') {
          this.conversation.human.push(this.Account.human[0].id);
        }
        let { error, data, status } = await create(this.conversationEntity, this.conversation);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.message.conversation = data.id;
          this.message.sender = ['agency', 'caseworker'].indexOf(session.role()) > -1 ? this.Agency.human[0] : this.Account.human[0].id;
          this.saveMessage();
        }
      }
    },
    async saveMessage () {
      let { error, data, status } = await create(this.entity, this.message);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        // this.Message.push(data);
        // let messageData = [];
        // messageData.message = data.id;
        // this.Conversation[this.conversationIndex].message.push(messageData);
        swal.fire({
          type: 'success',
          title: 'Message sent successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            if (this.$route.query.preUrl === 'Messages') {
              this.$router.push({ path: `/messages` });
            } else {
              this.$router.push({ path: session.role() === 'parent' ? `/dashboard` : `/agency/dashboard` });
            }
          }
        });
        this.updateConversationList();
      }
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      if (this.$route.query.preUrl === 'Messages') {
        this.$router.push({ path: `/messages` });
      } else {
        this.$router.push({ path: session.role() === 'parent' ? `/dashboard` : `/agency/dashboard` });
      }
    }      
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messages/add.vue